import Flickity from 'flickity';
require('flickity-imagesloaded');

export default function gallery() {
  document.querySelectorAll('[data-gallery-carousel]').forEach((element) => {
    new Flickity(element, {
      prevNextButtons: true,
      pageDots: false,
      contain: true,
      groupCells: 3,
      cellAlign: 'left',
      imagesLoaded: true,
    });
  });
}
